// imports section Start
import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
  Button,
  Stack,
  TextField,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Link,
  InputAdornment,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useStyles, lightTheme } from "../../assets/styles/Theme";
import PointOfOrderImage from "../../assets/images/login_bg.jpg";
import login_bg_1 from "../../assets/images/login_bg_1.jpg";
import login_bg_2 from "../../assets/images/login_bg_2.jpg";
import login_bg_3 from "../../assets/images/login_bg_3.jpg";
import login_bg_4 from "../../assets/images/login_bg_4.jpg";
import login_bg_5 from "../../assets/images/login_bg_5.jpg";
import lg_pizza from "../../assets/images/lg_burger.png";
import lg_burger from "../../assets/images/lg_pizza.png";
import { Person, Lock, AccountCircle } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { LOGIN_API } from "../../api/ApiModel";
import { setUserParams } from "../../store/ReduxUser";
import { externalpostApi } from "../../services/external/externalApis";
import { useDispatch } from "react-redux";
import { CON_MODULECODE,CON_MODULEKEY } from "../../utils/sys/Constants";
import { setAccessRights } from "../../store/ReduxAccessRight";
import { setCashierUserRefCode } from "../../store/ReduxCashierCartReducer";
import SnackbarMessage from "../../components/common/SnackbarMessage";
import { LOGIN_FAILED, LOGIN_SUCCESS } from "../../utils/sys/Messages";
import { ThemeProvider } from "@mui/material/styles";
import { setAccessModules } from "../../store/ReduxAccessModules";
// imports section End

const preventDefault = (event) => event.preventDefault();

function Login() {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [snackbarOpen, setSnackbarOpen] = useState(false); // Control Snackbar visibility
  const [snackbarMessage, setSnackbarMessage] = useState(""); // Snackbar message
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  // Hooks end

  // Handlers start
  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  // Custom Image Slider Component
  const ImageSlider = () => {
    const images = [
      login_bg_1,
      login_bg_2,
      login_bg_3,
      login_bg_4,
      login_bg_5,
      PointOfOrderImage,
    ]; // Array of images
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
      const interval = setInterval(() => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, 3000); // Change image every 3 seconds

      return () => clearInterval(interval); // Clean up the interval on component unmount
    }, []);

    return (
      <Box
        component="img"
        src={images[currentImageIndex]} // Display the current image
        alt="Point of Order System"
        sx={{
          transition: "opacity 1s ease-in-out",

          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: 2,

          position: "relative",
          // animation: "slideIn 3s ease-in-out forwards",
          "@keyframes slideIn": {
            "0%": { transform: "translateX(-100%)" }, // Starts off-screen from left
            "100%": { transform: "translateX(0)" }, // Ends at the normal position
          },
        }}
      />
    );
  };
  // Handlers end

  // API calls start
  const handleLogin = async () => {
    try {
      var loginResponse = await externalpostApi(LOGIN_API, {
        username,
        password,
        appModule: CON_MODULECODE,
        appToken: CON_MODULEKEY,
      });
      loginResponse = loginResponse.value;

      const userData = loginResponse.user;
      const accessRightsData = loginResponse.accessRights;
      const accessModulesData = loginResponse.accessModules;
      // Dispatch user data and access rights to redux
      dispatch(setUserParams(userData));
      dispatch(setAccessRights(accessRightsData)); // Dispatch access rights
      dispatch(setAccessModules(accessModulesData));
      setSnackbarMessage(LOGIN_SUCCESS);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);

      navigate("/home", {
        state: { snackbarMessage: LOGIN_SUCCESS, snackbarSeverity: "success" },
      });
    } catch (error) {
      console.error("Login failed:", error);
      setError("Login failed. Please check your credentials and try again.");
      setSnackbarMessage(LOGIN_FAILED);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };
  // API calls end

  return (
    <ThemeProvider theme={lightTheme}>
      <Box sx={styles.login_container}>
        {/* Background Shape Animation */}
        <Box sx={styles.shape1}>
          <Box
            component="img"
            src={lg_pizza}
            alt="Point of Order System"
            sx={styles.img_lg_card_shape1}
          />
        </Box>
        <Box sx={styles.shape2}>
          <Box
            component="img"
            src={lg_burger}
            alt="Point of Order System"
            sx={styles.img_lg_card_shape1}
          />
        </Box>
        <Box zIndex={2} width={"auto"}>
          <Grid container sx={styles.login_card_container}>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              xl={6}
              sx={styles.login_card_left}
            >
              {/* New Image */}
              {/* <Box
              component="img"
              src={PointOfOrderImage}
              alt="Point of Order System"
              sx={styles.img_login_card}
            /> */}

              <ImageSlider />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              xl={6}
              sx={styles.login_card_right}
            >
              <Typography variant="h1" sx={styles.retro_text}>
                Hello,
              </Typography>
              <Typography variant="h2" sx={styles.retro_text}>
                Welcome Back!
              </Typography>

              <Box
                component="form"
                sx={{
                  "& > :not(style)": { my: 3 },
                }}
                noValidate
                autoComplete="off"
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <AccountCircle
                    sx={{ color: theme.palette.text.icons, mr: 1, my: 0.5 }}
                  />
                  <TextField
                    id="txtUsername"
                    label="Username"
                    variant="outlined"
                    fullWidth
                    size="small"
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </Box>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Lock
                    sx={{ color: theme.palette.text.icons, mr: 1, my: 0.5 }}
                  />
                  <TextField
                    id="txtPassword"
                    label="Password"
                    size="small"
                    type="password"
                    variant="outlined"
                    fullWidth
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </Box>
              </Box>

              <Stack
                spacing={2}
                direction="row"
                mt={4}
                justifyContent={"flex-end"}
              >
                <Button
                  fullWidth
                  onClick={handleLogin}
                  variant="contained"
                  size="medium"
                  sx={styles.login_btn}
                >
                  Log In
                </Button>
              </Stack>
            </Grid>
          </Grid>
          <Box textAlign={"right"} width={"100%"}>
            {" "}
            <Typography variant="caption" sx={styles.login_retro_text}>
              Restaurant Management System
            </Typography>
          </Box>
        </Box>

        <SnackbarMessage
          open={snackbarOpen}
          handleClose={handleCloseSnackbar}
          message={snackbarMessage}
          severity={snackbarSeverity} // Dynamic severity (success or error)
        />
      </Box>{" "}
    </ThemeProvider>
  );
}

export default Login;
